module.exports = __webpack_public_path__ + "parth8.ae5e2b5567682855333e.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/parth8.png
// module id = ../../../../../src/assets/images/parth8.png
// module chunks = main